import { api } from "api/apiService";

/**
 * Завантажує список товарів з урахуванням параметрів фільтрації.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації, сортування та пагінації.
 * @returns {Promise<object>} Проміс, що повертає об'єкт з даними про товари.
 */
export const fetchProducts = (filters = {}) => {
  // Копіюємо лише ті фільтри, які мають реальне значення
  const cleanFilters = {};
  for (const key in filters) {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== "") {
      cleanFilters[key] = value;
    }
  }

  return api.get("/products", cleanFilters);
};

/**
 * Завантажує повний список постачальників.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами постачальників.
 */
export const fetchSuppliers = () => {
  return api.get("/suppliers");
};

/**
 * Оновлює статус конкретного товару за його артикулом.
 * @param {string} article - Артикул товару, який потрібно оновити.
 * @param {string} newStatus - Новий статус для товару.
 * @returns {Promise<object>} Проміс, що повертає відповідь від сервера.
 */
export const updateProductStatus = (article, newStatus) => {
  const url = `/products/${encodeURIComponent(article)}/updatestatus`;
  const body = { update_status: newStatus };
  return api.put(url, body);
};

/**
 * Масово оновлює статус оновлення для списку товарів.
 * @param {string[]} articles - Масив артикулів для оновлення.
 * @param {string} updateStatus - Новий статус ("Оновити ВСЕ", "Ігнорувати", "Оновити НАЯВНІСТЬ").
 * @returns {Promise<object>} Проміс з результатом оновлення.
 */
export const massUpdateProductStatus = (articles, updateStatus) => {
  const url = "/products/bulk/updatestatus";
  const body = {
    articles: articles,
    update_status: updateStatus,
  };
  return api.put(url, body);
};
